var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      class: { "is-active": _vm.isActive },
      attrs: { "data-component": "agent-status-settings-item" },
      on: {
        click: function ($event) {
          return _vm.$emit("click")
        },
      },
    },
    [
      _c(
        "div",
        { staticClass: "icon-wrapper" },
        [_c("or-icon", { attrs: { icon: _vm.icon } })],
        1
      ),
      _vm._v(" "),
      _c(
        "span",
        { staticClass: "label", attrs: { "data-label": "status-name" } },
        [_vm._v("\n    " + _vm._s(_vm.label) + "\n  ")]
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          class: { "is-disabled": _vm.isDisabled },
          attrs: { "data-button": "drag-start" },
          on: {
            click: function ($event) {
              $event.stopPropagation()
            },
          },
        },
        [_c("or-icon", { attrs: { icon: "drag_indicator" } })],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }